$(function() {
  
  sidebarDrawer._init();
  
});

var sidebarDrawer = {
  
  _init: function() {
    sidebarDrawer._bindEvents();
  },
  
  _bindEvents: function() {
    $('.sidebar-login-open').on('click', function(e) {
      e.preventDefault();
      sidebarDrawer._open('.sidebar.login');
    });
                                  
    $('.sidebar-cart-open').on('click', function(e) {
      e.preventDefault();
      sidebarDrawer._open('.sidebar.cart');
    });
    
    $('.sidebar-close').on('click', function() {
		sidebarDrawer._close($(this).parents('.sidebar'));
    });
    
    $('.sidebar-wrapper').on('click', function() {
		sidebarDrawer._close($(this).find('.sidebar'));
    });
    
    $('.sidebar').on('click', function(e){
    	e.stopPropagation();
    });

    // $(window).on('click', function() {
    //   sidebarDrawer._open('.sidebar.cart');
    // })
  },
  
  _open: function(container) {
    $('.sidebar-wrapper').fadeIn(250);
    $('.sidebar-wrapper').find(container).show();
    $('body').css('overflow', 'hidden');
  },
  
  _close: function(container) {
      $('.sidebar-wrapper').fadeOut(250);
    $('body').css('overflow', 'initial');
  }
                                  
  
}